import { ReactComponent as Reorder } from 'assets/icons/icon-reorder.svg';

export default Reorder;
